/**
 * Where a reloaded turn's rows are.
 *
 * A live turn and a reloaded one carry the same rows in different places, and
 * reading only one of them is why the Data chip worked while an answer was on
 * screen and went dead the moment the session was reopened.
 *
 * On the stream, the envelope is parsed as it arrives and the tables ride along
 * as `answer.data_sources`. On a reload, discover has moved them out of the
 * message content into their own column and puts them BACK inside the content
 * JSON before returning it (`api_service.py`: `parsed["data_sources"] = …`), so
 * they arrive parsed out of `content` instead — `processJSONContent` hands them
 * over as `dataSources`.
 *
 * Both, in the order of specificity, so neither path loses its rows.
 */
export const sessionRows = (message, processed) => {
  const parsed = processed && processed.dataSources;
  if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) return parsed;

  const fromAnswer = message && message.answer && message.answer.data_sources;
  if (fromAnswer && typeof fromAnswer === 'object' && Object.keys(fromAnswer).length > 0) return fromAnswer;

  // Explicitly null rather than `{}`: an empty map reads as "this turn produced
  // a result set with nothing in it", and a turn with no data channel at all
  // should not claim to have one.
  return null;
};
